import api from '../api';
import { OptionProps } from '@digital/ui';

const controller = 'crfTipoProjetofases';

export interface CrfTipoProjetoFase {
  id: string;
  nome: string;
  codigo: number;
}

export const getAllCrfTipoProjetoFase = () => api.get<CrfTipoProjetoFase[]>(controller);
export const getCrfTipoProjetoFaseById = (id: string) => api.get<CrfTipoProjetoFase>(`${controller}/${id}`);
export const getAllCrfTipoProjetoFaseOptions = () => {
  return getAllCrfTipoProjetoFase().then(Tipo =>
    (Tipo || []).map(t => ({ text: t.nome, value: t.id.toString() } as OptionProps)),
  );
}
